<template>
  <div class="w-full flex flex-col md:flex-row">
    <div class="w-full md:w-3/5 flex mb-5">
      <AbsensiBuat />
    </div>
    <div class="w-full md:w-2/5 md:ml-base">
      <AbsensiRiwayat />
    </div>
  </div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";
import vSelect from "vue-select";

import DialogCreate from "./DialogCreate";
import AbsensiBuat from "./components/AbsensiBuat.vue";
import AbsensiRiwayat from "./components/AbsensiRiwayat.vue";
import { digofHttp } from "@/axios";

export default {
  components: {
    "v-select": vSelect,
    DialogCreate,
    AbsensiBuat,
    AbsensiRiwayat,
    RadialProgressBar,
  },
  data() {
    return {
      attendance: null,
    };
  },
  mounted() {
    digofHttp
      .get("attendance")
      .then((r) => {
        this.attendance = r.data.data.attendance;
        this.$globalBus.$emit("updateAttendance", this.attendance);
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
</script>
